var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", {}, [
      _vm._v(
        "\n    セルモンエージェントの各種設定を行うことができます。\n    "
      ),
      _c("div", { staticClass: "mr-t-10" }, [
        _c("fieldset", { staticClass: "border" }, [
          _c("legend", { staticClass: "border" }, [_vm._v("FBA長期在庫")]),
          _vm._v(" "),
          _c("div", { staticClass: "pd-l-20 pd-r-20" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "border-bottom mr-b-10" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("toggle-button", {
                  attrs: {
                    labels: { checked: "ON", unchecked: "OFF" },
                    height: 30,
                    width: 62,
                    sync: true
                  },
                  model: {
                    value: _vm.enableNotice,
                    callback: function($$v) {
                      _vm.enableNotice = $$v
                    },
                    expression: "enableNotice"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mr-t-20" }, [
        _c("fieldset", { staticClass: "border" }, [
          _c("legend", { staticClass: "border" }, [_vm._v("セルモン出品")]),
          _vm._v(" "),
          _c("div", { staticClass: "pd-l-20 pd-r-20" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "border-bottom mr-b-10" },
              [
                _vm._m(3),
                _vm._v(" "),
                _c("toggle-button", {
                  attrs: {
                    labels: { checked: "ON", unchecked: "OFF" },
                    height: 30,
                    width: 62,
                    sync: true
                  },
                  model: {
                    value: _vm.enableNoticeSelmon,
                    callback: function($$v) {
                      _vm.enableNoticeSelmon = $$v
                    },
                    expression: "enableNoticeSelmon"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-right mr-t-10" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-warning w-120",
            attrs: { disabled: _vm.disableUpdate },
            on: {
              click: function($event) {
                _vm.handleClickUpdate()
              }
            }
          },
          [_vm._v("更新")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", {}, [
      _vm._v(
        "\n            次回のAmazon請求において、FBA長期在庫追加手数料の対象商品がある場合、メールで通知を受け取ります。"
      ),
      _c("br"),
      _vm._v(
        "\n            毎月5日、20日時点で対象商品がある場合にのみ通知します。"
      ),
      _c("br"),
      _vm._v(
        "\n            プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "text-size-20 text-primary font-bold pd-r-20" },
      [
        _c("i", {
          staticClass: "fa fa-pencil-square text-size-28",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("\n              Amazon返送納品の提案を通知する\n            ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", {}, [
      _vm._v(
        "\n            セルモンへ出品可能な商品がある場合、メールで通知を受け取ります。"
      ),
      _c("br"),
      _vm._v(
        "\n            毎月10日、25日時点で対象商品がある場合にのみ通知します。"
      ),
      _c("br"),
      _vm._v(
        "\n            プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "text-size-20 text-primary font-bold pd-r-20" },
      [
        _c("i", {
          staticClass: "fa fa-pencil-square text-size-28",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("\n              セルモンへの出品提案を通知する\n            ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af7574d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af7574d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/AgentNotice.vue
// module id = null
// module chunks = 